// hooks/useRoleCheck.js
import { useAuth } from "../context/AuthContext";

export const useHasPermission = (allowedRoles = []) => {
   const { getUserRoles } = useAuth();
   const userRoles = getUserRoles();
  return allowedRoles.some(role => userRoles.includes(role));
};
